import { ProductSource, ProviderSource } from '@getvim-core-apps/organizations';

export interface SourceConfigurations {
  supportIcdCpt: boolean;
  supportLanguage: boolean;
  supportDistance: boolean;
  supportOrdersButton: boolean;
  supportOrdersButtonInSignedReferralOnly: boolean;
  supportPlaceOfService: boolean;
  supportFacilityName: boolean;
  supportCost: boolean;
  supportWiderDistanceFilter: boolean;
  defaultDistanceFilter: number;
  useSourceFreeText: boolean;
  supportInsurancePlanInput: boolean;
  supportNetworkInput: boolean;
  collapsePreferredProviders: boolean;
  supportReferralRequest: boolean;
  supportsAcceptingNewPatientsLongTooltip: boolean;
  maxCptsPerSearch: number;
  resultsPerPage: number;
  supportScoreRatingBadges: boolean;
  supportNetworkStatusBadge: boolean;
  supportOpeningHours: boolean;
  useGarnersSpecialtiesInput: boolean;
  useGenericSearchTitles: boolean;
  useGeoCoordinatesOnly: boolean;
  supportQuickSpecialties: boolean;
  supportAcceptingNewPatientsInCard: boolean;
  displayDistanceInExportDetails: boolean;
}

export enum SourceConfigurationTypes {
  AUTHENTICATED = 'authenticated',
}

export interface SourceConfig {
  [SourceConfigurationTypes.AUTHENTICATED]: SourceConfigurations;
}

export type WidgetSource = ProductSource | ProviderSource;
